export { default as ItemsIndexTableWrapper } from './ItemsIndexTableWrapper';
